import React from 'react';
import { Button, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = ({ size = 'middle', type = 'text', className = '' }) => {
  const { currentTheme, toggleTheme } = useTheme();

  const isLight = currentTheme === 'light';

  return (
    <Tooltip title={isLight ? 'Alternar para tema escuro' : 'Alternar para tema claro'}>
      <Button
        type={type}
        size={size}
        icon={isLight ? <MoonOutlined /> : <SunOutlined />}
        onClick={toggleTheme}
        className={className}
        aria-label={isLight ? 'Alternar para tema escuro' : 'Alternar para tema claro'}
      />
    </Tooltip>
  );
};

export default ThemeToggle;